import { render, staticRenderFns } from "./event-page-open-settings-wrapper.vue?vue&type=template&id=62bb54ca&scoped=true&"
import script from "./event-page-open-settings-wrapper.vue?vue&type=script&lang=js&"
export * from "./event-page-open-settings-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./event-page-open-settings-wrapper.vue?vue&type=style&index=0&id=62bb54ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb54ca",
  null
  
)

export default component.exports